import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[60] flex flex-col bg-black",
  role: "dialog",
  "aria-modal": "true"
};
const _hoisted_2 = {
  class: "flex items-center gap-3 px-5 py-3 bg-slate-900 text-white shrink-0 border-b border-slate-700"
};
const _hoisted_3 = {
  class: "flex-1 min-w-0"
};
const _hoisted_4 = {
  class: "text-sm font-medium text-white truncate"
};
const _hoisted_5 = {
  class: "text-xs text-slate-400 mt-0.5"
};
const _hoisted_6 = {
  class: "mr-2"
};
const _hoisted_7 = {
  class: "text-slate-400"
};
const _hoisted_8 = ["disabled"];
const _hoisted_9 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center"
};
const _hoisted_10 = {
  key: 1,
  class: "min-h-full flex items-center justify-center p-6"
};
const _hoisted_11 = ["src", "alt"];
const _hoisted_12 = {
  key: 2,
  class: "w-full h-full",
  style: {
    "min-height": "calc(100vh - 56px)"
  }
};
const _hoisted_13 = {
  key: 3,
  class: "w-full min-h-full bg-white"
};
const _hoisted_14 = {
  key: 4,
  class: "excel-preview-pane"
};
const _hoisted_15 = {
  key: 5,
  class: "office-preview-pane"
};
const _hoisted_16 = ["src"];
const _hoisted_17 = {
  key: 6,
  class: "absolute inset-0 flex items-center justify-center"
};
const _hoisted_18 = {
  class: "text-center"
};
const _hoisted_19 = ["disabled"];
const _hoisted_20 = {
  key: 7,
  class: "absolute inset-0 flex items-center justify-center bg-black/80"
};
const _hoisted_21 = {
  class: "text-center"
};
const _hoisted_22 = ["disabled"];
import { computed, defineAsyncComponent, onBeforeUnmount, ref, watch } from 'vue';
import FileIcon from './FileIcon.vue';
import { getPreviewStrategy, getFileName, getFileSize, getFileUrl, getFileType } from '@/utils/fileType';
import '@vue-office/docx/lib/index.css';
import '@vue-office/excel/lib/index.css';
export default {
  __name: 'FilePreviewModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    file: {
      type: [Object, String],
      default: null
    },
    showPrev: {
      type: Boolean,
      default: false
    },
    showNext: {
      type: Boolean,
      default: false
    },
    loader: {
      type: Function,
      default: null
    }
  },
  emits: ['update:modelValue', 'prev', 'next'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const pdfComp = defineAsyncComponent(() => import('@vue-office/pdf'));
    const docxComp = defineAsyncComponent(() => import('@vue-office/docx'));
    const xlsxComp = defineAsyncComponent(() => import('@vue-office/excel'));
    const loading = ref(true);
    const error = ref(false);
    const downloadLoading = ref(false);
    const loadedUrl = ref('');
    const loadedObjectUrl = ref(false);
    const loadedContentType = ref('');
    let loadSeq = 0;
    const effectiveFile = computed(() => {
      if (!loadedContentType.value || !props.file || typeof props.file !== 'object') return props.file;
      return {
        ...props.file,
        contentType: loadedContentType.value
      };
    });
    const strategy = computed(() => effectiveFile.value ? getPreviewStrategy(effectiveFile.value) : 'download');
    const fileName = computed(() => getFileName(props.file));
    const fileSize = computed(() => getFileSize(props.file));
    const fileUrl = computed(() => getFileUrl(props.file));
    const shouldLoadPreview = computed(() => Boolean(props.file && props.loader && typeof props.file === 'object' && props.file.previewMode === 'blob'));
    const displayUrl = computed(() => shouldLoadPreview.value ? loadedUrl.value : loadedUrl.value || fileUrl.value);
    const officeViewerUrl = computed(() => {
      if (strategy.value !== 'office' || !displayUrl.value) return '';
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(displayUrl.value)}`;
    });
    const downloadable = computed(() => Boolean(getDownloadSource(props.file) || displayUrl.value));
    const typeBadgeMap = {
      image: '图片',
      pdf: 'PDF',
      docx: 'Word',
      xlsx: 'Excel',
      doc: 'Word',
      xls: 'Excel',
      ppt: 'PPT',
      pptx: 'PPT',
      archive: '压缩包',
      video: '视频',
      audio: '音频',
      text: '文本',
      file: '文件'
    };
    const typeBadge = computed(() => {
      if (!props.file) return '文件';
      return typeBadgeMap[getFileType(effectiveFile.value)] || '文件';
    });
    const previewBodyClass = computed(() => {
      if (strategy.value === 'xlsx' || strategy.value === 'office') {
        return 'flex-1 overflow-hidden bg-white relative';
      }
      return 'flex-1 overflow-auto bg-black relative';
    });
    watch(() => props.modelValue, v => {
      if (v) {
        loadPreview();
      } else {
        clearLoadedUrl();
      }
    });
    watch(() => props.file, () => {
      if (props.modelValue) {
        loadPreview();
      }
    });
    function close() {
      emit('update:modelValue', false);
    }
    function onLoad() {
      loading.value = false;
      error.value = false;
    }
    function onError() {
      loading.value = false;
      error.value = true;
    }
    async function loadPreview() {
      const seq = ++loadSeq;
      clearLoadedUrl();
      loadedContentType.value = '';
      error.value = false;
      if (!shouldLoadPreview.value) {
        loading.value = strategy.value !== 'download';
        return;
      }
      loading.value = true;
      try {
        const result = await props.loader(props.file, {
          purpose: 'preview'
        });
        if (seq !== loadSeq) return;
        setLoadedUrl(result);
      } catch {
        if (seq === loadSeq) {
          error.value = true;
          loading.value = false;
        }
      }
    }
    function setLoadedUrl(result) {
      clearLoadedUrl();
      const payload = result?.data ?? result;
      const contentType = result?.contentType || result?.headers?.['content-type'] || payload?.type || props.file?.contentType;
      loadedContentType.value = contentType || '';
      if (typeof payload === 'string') {
        loadedUrl.value = payload;
        loadedObjectUrl.value = false;
      } else if (payload instanceof Blob) {
        loadedUrl.value = URL.createObjectURL(payload);
        loadedObjectUrl.value = true;
      } else {
        loadedUrl.value = fileUrl.value;
        loadedObjectUrl.value = false;
      }
      loading.value = strategy.value !== 'download';
    }
    function clearLoadedUrl() {
      if (loadedObjectUrl.value && loadedUrl.value) {
        URL.revokeObjectURL(loadedUrl.value);
      }
      loadedUrl.value = '';
      loadedObjectUrl.value = false;
      loadedContentType.value = '';
    }
    async function handleDownload() {
      if (props.loader && typeof props.file === 'object' && props.file.previewMode === 'blob') {
        await downloadWithLoader();
        return;
      }
      const url = getDownloadSource(props.file) || displayUrl.value;
      if (!url) return;
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName.value || '';
      a.target = '_blank';
      a.rel = 'noopener';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    async function downloadWithLoader() {
      if (downloadLoading.value) return;
      downloadLoading.value = true;
      try {
        const result = await props.loader(props.file, {
          purpose: 'download'
        });
        const payload = result?.data ?? result;
        if (payload instanceof Blob) {
          downloadBlob(payload, fileName.value);
          return;
        }
        const url = typeof payload === 'string' ? payload : getDownloadSource(props.file) || displayUrl.value;
        if (url) downloadUrl(url, fileName.value);
      } finally {
        downloadLoading.value = false;
      }
    }
    function downloadBlob(blob, name) {
      const url = URL.createObjectURL(blob);
      downloadUrl(url, name);
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
    function downloadUrl(url, name) {
      const a = document.createElement('a');
      a.href = url;
      a.download = name || '';
      a.target = '_blank';
      a.rel = 'noopener';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    function getDownloadSource(file) {
      if (!file || typeof file === 'string') return '';
      return file.downloadSource || file.downloadUrl || '';
    }
    onBeforeUnmount(() => {
      loadSeq++;
      clearLoadedUrl();
    });
    return (_ctx, _cache) => {
      const _directive_modal_a11y = _resolveDirective("modal-a11y");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [__props.modelValue ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(FileIcon, {
        file: __props.file,
        class: "w-8 h-8"
      }, null, 8, ["file"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(fileName.value), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(fileSize.value), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(typeBadge.value), 1)])]), downloadable.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "px-3 py-1.5 text-sm text-slate-200 hover:text-white border border-slate-600 hover:border-slate-400 hover:bg-slate-700 rounded-lg flex items-center gap-1.5 shrink-0",
        disabled: downloadLoading.value,
        onClick: handleDownload
      }, [_cache[2] || (_cache[2] = _createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3"
      })], -1)), _createTextVNode(" " + _toDisplayString(downloadLoading.value ? '下载中' : '下载'), 1)], 8, _hoisted_8)) : _createCommentVNode("", true), __props.showPrev ? (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: "p-1.5 text-slate-300 hover:text-white hover:bg-slate-700 rounded-lg shrink-0",
        title: "上一个",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('prev'))
      }, [...(_cache[3] || (_cache[3] = [_createElementVNode("svg", {
        class: "w-5 h-5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M15 19l-7-7 7-7"
      })], -1)]))])) : _createCommentVNode("", true), __props.showNext ? (_openBlock(), _createElementBlock("button", {
        key: 2,
        class: "p-1.5 text-slate-300 hover:text-white hover:bg-slate-700 rounded-lg shrink-0",
        title: "下一个",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('next'))
      }, [...(_cache[4] || (_cache[4] = [_createElementVNode("svg", {
        class: "w-5 h-5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M9 5l7 7-7 7"
      })], -1)]))])) : _createCommentVNode("", true), _createElementVNode("button", {
        class: "p-1.5 text-slate-300 hover:text-white hover:bg-slate-700 rounded-lg shrink-0",
        onClick: close
      }, [...(_cache[5] || (_cache[5] = [_createElementVNode("svg", {
        class: "w-5 h-5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M6 18L18 6M6 6l12 12"
      })], -1)]))])]), _createElementVNode("div", {
        class: _normalizeClass(previewBodyClass.value)
      }, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[6] || (_cache[6] = [_createElementVNode("div", {
        class: "flex flex-col items-center gap-3 text-slate-400"
      }, [_createElementVNode("svg", {
        class: "w-8 h-8 animate-spin text-primary-500",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
      })]), _createElementVNode("span", {
        class: "text-sm"
      }, "加载中…")], -1)]))])) : _createCommentVNode("", true), strategy.value === 'image' && displayUrl.value ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("img", {
        src: displayUrl.value,
        alt: fileName.value,
        class: "max-w-full max-h-[calc(100vh-64px)] object-contain",
        onLoad: onLoad,
        onError: onError
      }, null, 40, _hoisted_11)])) : strategy.value === 'pdf' && displayUrl.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(pdfComp)), {
        src: displayUrl.value,
        class: "w-full h-full",
        onRendered: onLoad,
        onError: onError
      }, null, 40, ["src"]))])) : strategy.value === 'docx' && displayUrl.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(docxComp)), {
        src: displayUrl.value,
        class: "w-full h-full",
        onRendered: onLoad,
        onError: onError
      }, null, 40, ["src"]))])) : strategy.value === 'xlsx' && displayUrl.value ? (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(xlsxComp)), {
        src: displayUrl.value,
        class: "excel-preview-frame",
        onRendered: onLoad,
        onError: onError
      }, null, 40, ["src"]))])) : strategy.value === 'office' && officeViewerUrl.value ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("iframe", {
        src: officeViewerUrl.value,
        class: "office-preview-frame",
        title: "Office 预览",
        allowfullscreen: "",
        onLoad: onLoad,
        onError: onError
      }, null, 40, _hoisted_16)])) : (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(FileIcon, {
        file: __props.file,
        class: "w-16 h-16 mx-auto mb-3"
      }, null, 8, ["file"]), _cache[7] || (_cache[7] = _createElementVNode("p", {
        class: "text-sm text-slate-400 mb-4"
      }, "此文件类型暂不支持在线预览", -1)), downloadable.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "px-4 py-2 bg-primary-700 text-white text-sm rounded-lg hover:bg-primary-800",
        disabled: downloadLoading.value,
        onClick: handleDownload
      }, _toDisplayString(downloadLoading.value ? '下载中' : '下载文件'), 9, _hoisted_19)) : _createCommentVNode("", true)])])), error.value ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_cache[8] || (_cache[8] = _createElementVNode("svg", {
        class: "w-12 h-12 mx-auto mb-3 text-red-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M12 9v2m0 4h.01M5 19h14a2 2 0 001.84-2.75L13.74 4a2 2 0 00-3.48 0L3.16 16.25A2 2 0 005 19z"
      })], -1)), _cache[9] || (_cache[9] = _createElementVNode("p", {
        class: "text-sm text-slate-300 mb-3"
      }, "预览失败", -1)), downloadable.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "px-4 py-2 bg-primary-700 text-white text-sm rounded-lg hover:bg-primary-800",
        disabled: downloadLoading.value,
        onClick: handleDownload
      }, _toDisplayString(downloadLoading.value ? '下载中' : '下载文件查看'), 9, _hoisted_22)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)], 2)])), [[_directive_modal_a11y, close]]) : _createCommentVNode("", true)]);
    };
  }
};